export default {
  name: 'de',
  data: {
    modal: {
      cancel: 'Abbrechen',
      confirm: 'OK'
    },
    pagination: {
      prev: 'Vorherigen',
      next: 'Nächsten'
    },
    select: {
      empty: 'Keine Einträge... \\[ o_x ]/'
    },
    table: {
      empty: 'Keine Einträge... \\[ o_x ]/'
    }
  }
}